export default __webpack_public_path__ + "static/media/smile-lg.1100be7d.png";